import { TableRow } from "src/requests/table/types";
import { EditRowsWithColumns } from "src/requests/tableRowActions/types";

// eslint-disable-next-line import/prefer-default-export
export const getStringifiedTableRow = (tableRow?: TableRow): string => {
  if (!tableRow) return "";

  const tableRowValues = Object.values(tableRow.cells)
    .map(({ value }) => value)
    .map(String);

  const stringifiedValue = tableRowValues.reduce(
    (prev, curr) => `${prev} ${curr}`,
    ""
  );

  return stringifiedValue;
};

export const getStringifiedTableRows = (
  rowsWithColumns: EditRowsWithColumns
): string =>
  rowsWithColumns
    .reduce((prev, curr) => `${prev} ${getStringifiedTableRow(curr.row)}`, "")
    .trim();
